import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonnelPickerComponent } from './component/personnel-picker.component';
import { PersonnelPickerListSearchFormComponent } from './component/personnel-picker-list-search-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HvlFormItemModule, HvlFormMessageModule } from '@hvlng/framework-core/form';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { SharedModule } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { UiPageHeaderModule, UiSharedModule } from 'ui-shared';
import { PersonnelPickerListComponent } from './component/personnel-picker-list.component';
import { PersonnelPickerContentComponent } from './component/personnel-picker-content.component';
import {
    HrPerPersonnelSearchModule
} from "../personnel-operations/component/hr-per-personnel-search/hr-per-personnel-search.module";
import { HumanresourcesCommonSharedModule } from 'humanresources-common-shared';
import {KeyFilterModule} from "primeng/keyfilter";
import {PersonnelAdvancedSearchModule} from "../personnel-advanced-search/personnel-advanced-search.module";
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
@NgModule({
    exports: [PersonnelPickerComponent, PersonnelPickerContentComponent, PersonnelPickerListSearchFormComponent, PersonnelPickerListComponent],
    declarations: [PersonnelPickerComponent, PersonnelPickerContentComponent, PersonnelPickerListSearchFormComponent, PersonnelPickerListComponent],
    imports: [
        CommonModule,
        PrimengSharedModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        HvlFormItemModule,
        ToolbarModule,
        UiPageHeaderModule,
        TableModule,
        MenuModule,
        AccordionModule,
        UiSharedModule,
        TranslateModule,
        ToastModule,
        FormsModule,
        SharedModule,
        HvlFormMessageModule,
        HrPerPersonnelSearchModule,
        HumanresourcesCommonSharedModule,
        KeyFilterModule,
        PersonnelAdvancedSearchModule,
        InputGroupModule,
        InputGroupAddonModule
    ],
})
export class PersonnelPickerModule {}
